import {
  addDays,
  addHours,
  addMinutes,
  closestTo,
  eachHourOfInterval,
  startOfMonth,
  startOfToday,
  startOfWeek,
  subHours,
} from "date-fns";
import { LoremIpsum } from "lorem-ipsum";
import { v4 } from "uuid";
import { Note } from ".";

export const possibleBackgrounds = [
  "#ffff00",
  "#00ff00",
  "#00ffff",
  "#ff00ff",
  "#ff9900",
  "#FC7808",
  "#3ECB33",
  "#388E3C",
  "#00796B",
  "#16AEEF",
  "#0288D1",
  "#0000ff",
  "#000582",
  "#9900ff",
  "#744DA9",
  "#980000",
  "#ff0000",
  "#000000",
  "#ffffff",
  "#feecd8",
  "#EC766F",
  "#F9B00C",
  "#fbbc04",
  "#FFF563",
  "#fff9db",
  "#C2FF7E",
  "#9AFFE6",
  "#9FBEF8",
  "#CD99FA",
  "#FBC2E3",
  "#DFBE98",
  "#C1EDF7",
  "#E2E5E9",
  "#EDF0F1",
  "#e8eaed",
  "#F9F9F9",
];

let backgrounds = [...possibleBackgrounds];

let namesActions = [
  "Call ",
  "Email ",
  "Fax ",
  "Whatsapp ",
  "Facebook ",
  "Notify ",
  "Remind ",
  "Talk to ",
  "Speak to ",
];
let names = [
  "Bob",
  "Roger",
  "Benny",
  "Anna",
  "John",
  "Levy",
  "Julie",
  "Charlie",
  "Alexandre",
  "Robert",
  "Devon",
  "Susan",
  "John",
  "Mélanie",
  "Sophie",
  "Charlene",
  "Martin",
  "Diane",
  "Marie",
  "Johnny",
  "Vincent",
  "Kevin",
  "Travis",
  "Theophile",
];
let subjects = [
  "plants",
  "life",
  "the universe",
  "my cat",
  "goats",
  "yesterday's paper",
  "Schopenhauer",
  "the war on Christmas",
  "yes-men",
  "Star Trek",
  "eggplants",
  "overconfidence being a slow and insiduous killer",
  "the town",
  "responsibility",
  "awareness",
  "salads",
  "Camus",
  "government",
  "the reception",
  "poems",
  "goals",
  "chess",
  "tomatoes",
  "God's green Earth",
  "cosmology",
  "Sartre",
  "Q4 earnings",
  "synergy",
  "triangles",
  "memes",
  "the car",
  "downtempo",
  "Tame Impala",
  "Britney Spears",
  "old mistakes",
  "life and such",
  "other people",
  "smiles",
];

const lorem = new LoremIpsum({
  sentencesPerParagraph: {
    max: 8,
    min: 4,
  },
  wordsPerSentence: {
    max: 16,
    min: 4,
  },
});

const dumTitleGenerator = () => {
  shuffle(namesActions);
  shuffle(names);
  shuffle(subjects);
  return namesActions[0] + names[0] + " about " + subjects[0];
};

export const backgroundGenerator = () => {
  if (Math.random() < 0.66) {
    return "#ffffff";
  } else {
    shuffle(backgrounds);
    return backgrounds[0];
  }
};

let booleans = [true, false];
const randomBoolean = () => {
  shuffle(booleans);
  return booleans[0];
};

//@ts-ignore
function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const nextHours = eachHourOfInterval({
  start: new Date(),
  end: addDays(new Date(), 1),
});

export const dummyNoteGenerator: () => Note = () => {
  return {
    id: v4(),
    version: 1,
    title: dumTitleGenerator(),
    schedule: {
      type: "NONE",
    },
    completed: randomBoolean(),
    tags: ["Design"],
    background: backgroundGenerator(),
    created: new Date(),
  };
};

export const generateInitialNotes: () => Array<Note> = () => {
  return [
    /* Backlogs */
    {
      id: v4(),
      version: 1,
      title: dumTitleGenerator(),
      schedule: {
        type: "NONE",
      },
      completed: randomBoolean(),
      tags: ["Design"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: v4(),
      version: 1,
      title: dumTitleGenerator(),
      schedule: {
        type: "NONE",
      },
      completed: randomBoolean(),
      tags: ["Design"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: v4(),
      version: 1,
      title: dumTitleGenerator(),
      schedule: {
        type: "NONE",
      },
      completed: randomBoolean(),
      tags: ["Design"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    /* Big one */
    {
      id: "loremipsum",
      version: 1,
      title: lorem.generateSentences(8),
      schedule: {
        type: "NONE",
      },
      completed: randomBoolean(),
      tags: ["Design"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: "secondipsum",
      version: 1,
      title: lorem.generateSentences(8),
      schedule: {
        type: "NONE",
      },
      completed: randomBoolean(),
      tags: ["Design"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: "secondbytheway",
      version: 1,
      title: "Second time is the chime",
      schedule: {
        type: "NONE",
      },
      completed: randomBoolean(),
      tags: ["Design"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: "firstbytheway",
      version: 1,
      title: "First of my name",
      schedule: {
        type: "NONE",
      },
      completed: randomBoolean(),
      tags: ["Design"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: "uno",
      version: 1,
      title: "Uno",
      schedule: {
        type: "DAY",
        day: startOfToday(),
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: "dos",
      version: 1,
      title: "Dos",
      schedule: {
        type: "DAY",
        day: startOfToday(),
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: "tres",
      version: 1,
      title: "Tres",
      schedule: {
        type: "DAY",
        day: startOfToday(),
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: v4(),
      version: 1,
      title: "Caravaggio",
      schedule: {
        type: "WEEK",
        week: startOfWeek(addDays(new Date(), 7), { weekStartsOn: 1 }),
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: v4(),
      version: 1,
      title: dumTitleGenerator(),
      schedule: {
        type: "WEEK",
        week: startOfWeek(new Date(), { weekStartsOn: 1 }),
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: v4(),
      version: 1,
      title: dumTitleGenerator(),
      schedule: {
        type: "MONTH",
        month: startOfMonth(new Date()),
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: v4(),
      version: 1,
      title: dumTitleGenerator(),
      schedule: {
        type: "MONTH",
        month: startOfMonth(new Date()),
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    /* On calendar */
    {
      id: "1 to 2",
      version: 1,
      title: "One to Two",
      schedule: {
        type: "EXACT",
        start: closestTo(addHours(new Date(), 1), nextHours),
        end: closestTo(addHours(new Date(), 2), nextHours),
        width: 1,
        offset: 0,
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: "4 to 6",
      version: 1,
      title: "Four to Six",
      schedule: {
        type: "EXACT",
        start: closestTo(addHours(new Date(), 4), nextHours),
        end: closestTo(addHours(new Date(), 6), nextHours),
        width: 0.5,
        offset: 0,
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: "5 to 8",
      version: 1,
      title: "Five to Eight",
      schedule: {
        type: "EXACT",
        start: closestTo(addHours(new Date(), 5), nextHours),
        end: closestTo(addHours(new Date(), 8), nextHours),
        offset: 0.5,
        width: 0.5,
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: "7 to 9",
      version: 1,
      title: "7 to 9",
      schedule: {
        type: "EXACT",
        start: closestTo(addHours(new Date(), 7), nextHours),
        end: closestTo(addHours(new Date(), 9), nextHours),
        offset: 0,
        width: 0.5,
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: "11.5 to  12.5",
      version: 1,
      title: "11.5 to  12.5",
      schedule: {
        type: "EXACT",
        start: addMinutes(addHours(new Date(), 11), 30),
        end: addMinutes(addHours(new Date(), 12), 30),
        offset: 0.5,
        width: 0.5,
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: "11 to 12",
      version: 1,
      title: "11 to 12",
      schedule: {
        type: "EXACT",
        start: closestTo(addHours(new Date(), 11), nextHours),
        end: closestTo(addHours(new Date(), 12), nextHours),
        offset: 0,
        width: 0.5,
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: "Papa bear",
      version: 1,
      title: "Papa bear",
      schedule: {
        type: "EXACT",
        start: closestTo(addHours(new Date(), 16), nextHours),
        end: closestTo(addHours(new Date(), 17), nextHours),
        offset: 0,
        width: 0.33,
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: "Mama bear",
      version: 1,
      title: "Mama bear",
      schedule: {
        type: "EXACT",
        start: closestTo(addHours(new Date(), 16), nextHours),
        end: closestTo(addHours(new Date(), 17), nextHours),
        offset: 0.33,
        width: 0.33,
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: "Baby bear",
      version: 1,
      title: "Baby bear",
      schedule: {
        type: "EXACT",
        start: closestTo(addHours(new Date(), 16), nextHours),
        end: closestTo(addHours(new Date(), 17), nextHours),
        offset: 0.66,
        width: 0.34,
      },
      completed: randomBoolean(),
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    /* Overdues */
    {
      id: v4(),
      version: 1,
      title: "Ashes to ashes",
      schedule: {
        type: "EXACT",
        start: subHours(closestTo(addHours(new Date(), 4), nextHours), 36),
        end: subHours(closestTo(addHours(new Date(), 4), nextHours), 32),
        offset: 0,
        width: 1,
      },
      completed: false,
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
    {
      id: v4(),
      version: 1,
      title: "Life on mars",
      schedule: {
        type: "DAY",
        day: subHours(startOfToday(), 24),
      },
      completed: false,
      tags: ["General"],
      background: backgroundGenerator(),
      created: new Date(),
    },
  ];
};
